import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-prasad-angular',
  template: `
    <p>
      prasad-angular works!
    </p>
  `,
  styles: [
  ]
})
export class PrasadAngularComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
